module.exports = __webpack_public_path__ + "assets/img/Merkliste.9f5913a1.jpg";